(() => {
  // app/scripts/recently-viewed.js
  if (!customElements.get("recently-viewed")) {
    class RecentlyViewed extends HTMLElement {
      constructor() {
        super();
        this.addRecentlyViewedProduct();
        this.getRecentlyViewedProducts();
      }
      addRecentlyViewedProduct() {
        if (window.theme.routes.pageType != "product")
          return;
        const delay = window.theme.localforage && window.theme.localforage.getItem ? 0 : 300;
        setTimeout(() => {
          window.theme.localforage.getItem("recentlyViewed").then((value) => {
            let currentValue = value ? value.split("|") : [];
            let newValue = [...currentValue];
            if (window.theme.product_hidden != 1) {
              newValue = [window.theme.product.handle, ...newValue];
            }
            newValue = [...new Set(newValue)];
            if (!newValue)
              return;
            if (newValue.length > 10)
              newValue.length = 10;
            window.theme.localforage.setItem("recentlyViewed", newValue.join("|"));
          });
        }, delay);
      }
      getRecentlyViewedProducts() {
        const delay = window.theme.localforage && window.theme.localforage.getItem ? 0 : 300;
        setTimeout(() => {
          window.theme.localforage.getItem("recentlyViewed").then((value) => {
            if (!value)
              return;
            let array = value.split("|");
            if (theme.routes.pageType == "product") {
              array = array.filter((item) => item != theme.product.handle);
            }
            this.handleArray = array;
            const handleIntersection = (entries, observer) => {
              if (!entries[0].isIntersecting)
                return;
              observer.unobserve(this);
              this.renderRecentlyViewedProducts();
            };
            new IntersectionObserver(handleIntersection.bind(this), {
              rootMargin: "400px 0px 400px 0px"
            }).observe(this);
          });
        }, delay);
      }
      renderRecentlyViewedProducts() {
        let limit = +this.dataset.limit;
        if (this.handleArray.length > limit)
          this.handleArray.length = limit;
        const urls = this.handleArray.map((productHandle, index) => {
          return `${theme.routes.searchUrl}?view=product-card&q=${productHandle}`;
        });
        Promise.all(urls.map((url) => fetch(url).then((resp) => resp.text()))).then((texts) => {
          const newTexts = texts.filter(Boolean).map((text) => {
            const div = document.createElement("div");
            div.innerHTML = text;
            div.classList.add("swiper-slide");
            return div.outerHTML.toString();
          });
          this.loaded(newTexts.join(""));
        });
      }
      loaded(html) {
        const div = document.createElement("div");
        div.innerHTML = html;
        const itemList = div.querySelectorAll(".swiper-slide");
        if (!itemList.length)
          return;
        const wrapper = this.querySelector(".jsSlider");
        [...itemList].slice(0, parseInt(this.dataset.limit)).forEach((item) => {
          wrapper.insertAdjacentElement("afterbegin", item);
        });
        this.classList.add("recommend-initialized");
        this.querySelector(".js-container")?.classList.remove("none");
        this.querySelector("swiper-component")?.load();
      }
      updateRecentlyViewedProduct(productHandle) {
        window.theme.localforage.getItem("recentlyViewed").then((value) => {
          let currentValue = value ? value.split("|") : [];
          let newValue = currentValue.filter((item) => item != productHandle);
          if (!newValue)
            return;
          window.theme.localforage.setItem("recentlyViewed", newValue.join("|"));
        });
      }
    }
    customElements.define("recently-viewed", RecentlyViewed);
  }
})();
